import { createLink, type LinkComponent } from '@tanstack/react-router'
import { Button, type ButtonProps } from 'antd'
import { forwardRef } from 'react'

const CreatedButtonLink = createLink(
  forwardRef<HTMLAnchorElement, ButtonProps>((props, ref) => <Button ref={ref as never} {...props} />),
)

export const ButtonLink: LinkComponent<typeof CreatedButtonLink> = props => (
  <CreatedButtonLink preload="intent" {...props} />
)
